import Default from "./Default.svelte";
import Word from "./Word.svelte";

const routes = [
  {
    name: "/",
    component: Default
  },
  { name: "word/:title", component: Word }
];

export { routes };
